module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_7016.edc21f4e.png";